/**
 * Stacked cargo on the east quay (lifted from lantern-water's `world.js`
 * `createTown`): seven braced crates in rows of three, the last two on top.
 * Origin at the first crate (the prototype's 12.2, 13.5). No params. Their
 * colliders (one 0.64 square per crate) are the scene record's.
 */
import * as THREE from 'three';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'crate_stack',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    for (let i = 0; i < 7; i += 1) ctx.crate(root, (i % 3) * 0.72, Math.floor(i / 3) * 0.8, 0.64, i > 4 ? 0.15 : 0);
    return { root };
  },
};
